import {
	Component,
	Input,
	OnChanges,
	SimpleChanges,
	TemplateRef
} from '@angular/core';

import { HlsUtilService } from './HlsUtil.Service';

@Component({
	selector: 'vb-playback-unavailable',
	host: {
		'[class.smallSizePlayer]': 'isSmallSizePlayer'
	},
	template: `
		<span class="warningSign glyphicons white circle_exclamation_mark"></span>
		@if (playbackUnavailableMsgTemplate) {
			<ng-container
				[ngTemplateOutlet]="playbackUnavailableMsgTemplate"
				[ngTemplateOutletContext]="{ mediaError: mediaError, translations: translations, isRevConnectMeshFull: isRevConnectMeshFull }">
			</ng-container>
		} @else {
			<span [hidden]="isRevConnectMeshFull">
				{{ translations.playbackNotAvailable }}
			</span>
			<span
				[hidden]="!isRevConnectMeshFull">
				{{ translations.revConnectMeshFull }}
			</span>
		}
	`,
	standalone: false,
	styleUrl: './VbNoSupportedPlaybacks.Component.ng.less'
})
export class VbPlaybackUnavailableComponent implements OnChanges {
	@Input() public mediaError: any;
	@Input() public playbackUnavailableMsgTemplate: TemplateRef<any>;
	@Input() public translations: Record<string, string>;
	@Input() public isSmallSizePlayer: boolean;

	public isRevConnectMeshFull: boolean;

	constructor(
		private HlsUtilService: HlsUtilService
	) {}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.mediaError) {
			this.isRevConnectMeshFull = this.HlsUtilService.isRevConnectMeshFullError(this.mediaError);
		}
	}
}
